import script from "./VTableSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./VTableSummary.vue?vue&type=script&setup=true&lang=js"

import "./VTableSummary.vue?vue&type=style&index=0&id=6c56ddc4&scoped=true&lang=less"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c56ddc4"]])

export default __exports__